import { styled } from 'stitches.config'

export const Card = styled('div', {
  borderRadius: '$4',
  backgroundColor: '$accent-white',
  border: '1px solid $tertiary-300',
  boxShadow: '0px 3px 0 0 $colors$tertiary-300',
})

export const EditCard = styled('div', {
  '@bp1': {
    borderRadius: '$4',
    backgroundColor: '$accent-white',
    border: '1px solid $tertiary-300',
    boxShadow: '0px 3px 0 0 $colors$tertiary-300',
  },
})
